module.exports = __webpack_public_path__ + "static/media/error.60c95938.png";